import React from "react";
import "./DeleteModal.css";

const DeleteModal = ({ isOpen, onClose, onConfirm,isLoading, title = "Confirm Delete", message = "Are you sure you want to delete?" }) => {

  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay" onClick={onClose}>
      <div className="delete-modal-content" onClick={(e) => e.stopPropagation()}>
        <h3 className="delete-modal-title">{title}</h3>
        <p className="delete-modal-message">{message}</p>
        <div className="delete-modal-actions">
          <button className="delete-btn-cancel" onClick={onClose}
          disabled={isLoading}>
            Cancel
          </button>

          <button className="delete-btn-confirm" onClick={onConfirm}>
            {/* Delete */}
                         {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white", padding: 8 }}
                ></span>
              </>
            ) : (
              "Delete"
            )}

          </button>

        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
